import { LoadingSpinner } from '../loading-spinner/loading-spinner';

export const LoadingPlaceHolder = () => {
    return (
        <div class="h-[60vh] w-full flex flex-col items-center justify-center">
            <LoadingSpinner />
        </div>
    );
};